import { radii, shadows } from '@theme/utils'
import { colors } from '@theme/colors'

export const overlay = {
  background: colors.neutral.darkCharcoal,
  opacity: '.3!important',
}
export const dialog = {
  boxShadow: shadows.lg,
  bg: colors.neutral.white,
  borderRadius: radii.big,
}
